import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "filename", "filenameText", "removeFlag"];

  open() {
    this.inputTarget.click();
  }

  fileSelected() {
    const file = this.inputTarget.files[0];
    this.filenameTextTarget.textContent = file ? file.name : "";
    this.filenameTarget.classList.toggle("hidden", !file);
    if (file && this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "0";
    }
  }

  removeFile() {
    this.inputTarget.value = "";
    this.filenameTarget.classList.add("hidden");
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "1";
    }
  }
}
